import React from "react";
import MetaData from "../layout/MetaData";
import { useSelector } from "react-redux";
import { Link } from "react-router-dom";
import { calculateOrderCost } from "../../helpers/helpers";

const CalculateRideCost = () => {
  const { userAddressInfo, googleMap, labour, goodsInfo } = useSelector((state) => state.userAddressInfo);
  const { user } = useSelector((state) => state.auth);

  const distance = googleMap?.distance ? parseFloat(googleMap.distance.replace(/[^\d.]/g, '')) : 0;
  const vehicle = userAddressInfo?.vehicle;
  const { totalAmount } = calculateOrderCost(distance, vehicle);

  const DetailRow = ({ label, value }) => (
    <p className="mb-3 d-flex justify-content-between">
      <span className="text-secondary fw-medium">{label}</span>
      <span className="fw-bold">{value || '—'}</span>
    </p>
  );

  return (
    <>
      <MetaData title="Confirm Booking Info" />
      <div className="row d-flex justify-content-center" style={{ padding: '2rem 1rem' }}>
        <div className="col-12 col-lg-8">
          <div className="card p-4">
            <h3 className="mb-4">Review Booking</h3>

            <h5 className="text-primary fw-semibold mb-3">User Detail</h5>
            <DetailRow label="Name" value={user?.name} />
            <DetailRow label="Email" value={user?.email} />
            <hr />

            <h5 className="text-primary fw-semibold mb-3">Address Detail</h5>
            <DetailRow label="Starting Address" value={`${userAddressInfo?.startAddress}, ${userAddressInfo?.startCity}`} />
            <DetailRow label="Destination Address" value={`${userAddressInfo?.destinationAddress}, ${userAddressInfo?.destinationCity}`} />
            <DetailRow label="Distance" value={googleMap?.distance} />
            <hr />

            <h5 className="text-primary fw-semibold mb-3">Labour Detail</h5>
            <DetailRow label="Labours at Pickup" value={labour?.noOfLaboursStart || 0} />
            <DetailRow label="Labours at Destination" value={labour?.noOfLaboursDestination || 0} />
            <DetailRow label="Floors at Pickup" value={labour?.buildingFloorsStart || 0} />
            <DetailRow label="Floors at Destination" value={labour?.buildingFloorsDestination || 0} />
            <DetailRow label="Cargo Lift at Pickup" value={labour?.cargoLiftStart ? 'Yes' : 'No'} />
            <DetailRow label="Cargo Lift at Destination" value={labour?.cargoLiftDestination ? 'Yes' : 'No'} />
            <hr />

            <h5 className="text-primary fw-semibold mb-3">Goods & Vehicle</h5>
            <DetailRow label="Vehicle" value={userAddressInfo?.vehicle} />
            <DetailRow label="Loading Type" value={goodsInfo?.loadingType} />
            <DetailRow label="Weight" value={`${goodsInfo?.totalWeight} Kgs`} />
            <DetailRow label="Volume" value={`${goodsInfo?.volume} m³`} />
            <DetailRow label="Goods Type" value={goodsInfo?.goodsType} />
          </div>
        </div>

        <div className="col-12 col-lg-3 my-4">
          <div className="card p-4" id="order_summary">
            <h4 className="mb-4">Ride Summary</h4>
            <DetailRow label="Distance" value={googleMap?.distance} />
            <hr />
            <div className="text-center my-3">
              <p className="text-secondary mb-1">Total Amount</p>
              <h2 className="fw-bold text-primary">{totalAmount} PKR</h2>
            </div>
            <hr />
            <Link to="/payment_method" className="btn btn-primary w-100 py-3 fw-bold">
              Proceed to Payment
            </Link>
          </div>
        </div>
      </div>
    </>
  );
};

export default CalculateRideCost;